import {
    setSliceLyricDesc,
    setSliceTabIndex,
    setSliceLyricContent,
    setSliceIncidentalAudioInfo,
    setSliceAudioInfo,
    setSliceVocalAudioInfo,
    setSliceUploadAudioStatus,
    setSliceVocalUploadAudioStatus,
    setSliceIncidentalAudioStatus,
    setSlicePresetList,
    setSliceReferenceMusicList,
    setSliceReferenceVocalList,
    setSliceInstrumentalList,
    setSliceIsGenerateLyricsLoading,
    setSliceIsMultipleMode,
    setSliceSFXPrompt,
    setSliceHistoryTabIndex,
    setSliceSFXFreeNumCreationAction,
    setSliceSFXPresetList,
    setSliceInsPresetList,
    setSliceMusicDuration,
    setSliceInstrumentalDuration,
    setSliceSubTabIndex,
    setSliceMusicStyles,
    setSliceInstrumentStyles,
    setSliceM2MLyricContent,
    setSliceT2MLyricContent,
    setSliceMusicPrompt,
    setSliceInstrumentalPrompt,
    setSliceIsEnableLyricsT2M,
    AI_AUDIO_USE_CREDIT,
    setSliceTextToMusicFreeNum,
    setSliceTextToAccompanyFreeNum,
    setSliceMusicToMusicFreeNum,
    setSliceMusicToInstFreeNum,
} from '../slices/FJSliceAIAudioGenerator';
import FJNetworkStore from '../../store/FJNetworkStore.js';
import FJConstant from '../../constants/FJConstant.js';
import FJUtil from '../../util/FJUtil.js';
import {
    MAX_POLLING_ERROR_TIME,
    TASK_POLLING_INTERVAL,
    UPLOAD_FILE_TYPE_OF_AUDIO,
} from '../../config/dataConfig/FJGenerateData.js';
import { MAX_PROMPT_LENGTH } from '../../config/dataConfig/FJAIAudioGeneratorData.js';
import FJMessageStore from '../../store/FJMessageStore.js';
import FJLocalStore from '../../store/FJLocalStore.js';
import FJConfig from '../../config/FJConfig.js';
import FJImageStore from '../../store/FJImageStore.js';
import FJS3Config from '../../config/FJS3Config.js';
import FJActionModal from './FJActionModal';
import FJActionCommon from './FJActionCommon.js';
import {
    setSliceTaskStatusAction,
    setSliceHistoryListAction,
    setSliceHistoryListLoadStatusAction,
    setSliceSelectListAction,
} from '../slices/FJSliceCommon.js';
import FJActionRecord from './FJActionRecord.js';
import Download from '../../lib/download.js';
import FJAudioPlayManager from '../../store/FJAudioPlayManager.js';
import FJActionEditPage from './FJActionEditPage.js';

let f_timer = null;
let f_errorTime = 0;
let f_currentWaveId = null;

const _time15Error = () => {
    FJMessageStore.addMessage(FJLocalStore._('music-should-be-at-least-15s'), 'error');
};

const _time600Error = () => {
    FJMessageStore.addMessage(FJLocalStore._('music-should-be-within-10-mins'), 'error');
};

// 国旅歌词末尾的 ##
const _removeTrailingHash = str => {
    return str?.replace(/##$/, '');
};

const _combinePrompt = (origin_prompt, tag_style) => {
    const _prompts = [];
    origin_prompt && _prompts.push(origin_prompt);
    tag_style && _prompts.push(tag_style);
    return _prompts.join(', ');
};

const FJActionAIAudioGenerator = {
    resetAction: function () {
        return dispatch => {
            dispatch(FJActionAIAudioGenerator.setIsMultipleModeAction(false));
            dispatch(FJActionAIAudioGenerator.clearAudioInfoAction());
            dispatch(FJActionAIAudioGenerator.clearVocalAudioInfoAction());
            dispatch(FJActionAIAudioGenerator.clearIncidentalAudioInfoAction());
        };
    },
    setIsMultipleModeAction: function (bool) {
        return dispatch => {
            dispatch(setSliceIsMultipleMode(bool));
        };
    },
    setHistoryTabIndexAction: function (index) {
        return dispatch => {
            dispatch(setSliceHistoryTabIndex(index));
        };
    },
    setLyricDescAction: function (value) {
        return dispatch => {
            dispatch(setSliceLyricDesc(value));
        };
    },
    changeSFXPromptAction: function (value) {
        return dispatch => {
            dispatch(setSliceSFXPrompt(FJUtil.sliceByteLen(value, 200)));
        };
    },

    changeTabIndexAction: function (index) {
        return dispatch => {
            dispatch(setSliceTabIndex(index));
        };
    },

    /**
     * @deprecated 旧版本更新歌词内容，请用 changeM2MLyricContentAction
     * */
    setLyricContentAction: function (value) {
        return dispatch => {
            dispatch(setSliceLyricContent(FJUtil.sliceByteLen(value, 350)));
        };
    },

    setIncidentalAudioInfoAction: function (info) {
        return dispatch => {
            dispatch(setSliceIncidentalAudioInfo({ ...info }));
        };
    },

    setAudioInfoAction: function (info) {
        return dispatch => {
            dispatch(setSliceAudioInfo({ ...info }));
        };
    },

    setUploadAudioStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceUploadAudioStatus(status));
        };
    },

    setVocalAudioInfoAction: function (info) {
        return dispatch => {
            dispatch(setSliceVocalAudioInfo({ ...info }));
        };
    },

    setVocalAudioStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceVocalUploadAudioStatus(status));
        };
    },

    setIncidentalAudioStatusAction: function (status) {
        return dispatch => {
            dispatch(setSliceIncidentalAudioStatus(status));
        };
    },

    initAIAudioGeneratorAction: function () {
        return dispatch => {
            const recId = FJUtil.getQueryString(FJConstant.REC_ID);
            const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
            if (recIdInfo) {
                window.localStorage.removeItem(recId);
                const { info, job_type, lyrics, prompt, audio_duration, gen_scene } = recIdInfo;
                if (job_type === 17) {
                    const useInfo = info;
                    if (lyrics) {
                        dispatch(this.changeM2MLyricContentAction(lyrics));
                        dispatch(this.changeTabIndexAction(1));
                        dispatch(this.changeSubTabIndexAction(0));
                        if (useInfo.songId) {
                            dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
                            dispatch(
                                this.setAudioInfoAction({
                                    url:
                                        useInfo.songSource === FJConstant.AI_AUDIO_S3
                                            ? FJS3Config.S3_SERVER_HOST + FJConfig.originalSongKey + useInfo.songId
                                            : window.location.origin +
                                              FJConfig.presetPreviewPath +
                                              'audio/' +
                                              useInfo.songId,
                                    name: useInfo.songName,
                                    source: useInfo.songSource,
                                }),
                            );
                        }
                        if (useInfo.voiceId) {
                            dispatch(this.setVocalAudioStatusAction(FJConstant.SUCCESS));
                            dispatch(
                                this.setVocalAudioInfoAction({
                                    url:
                                        useInfo.voiceSource === FJConstant.AI_AUDIO_S3
                                            ? FJS3Config.S3_SERVER_HOST + FJConfig.originalSongKey + useInfo.voiceId
                                            : window.location.origin +
                                              FJConfig.presetPreviewPath +
                                              'audio/' +
                                              useInfo.voiceId,
                                    name: useInfo.voiceName,
                                    source: useInfo.voiceSource,
                                }),
                            );
                        }
                    } else {
                        dispatch(this.changeTabIndexAction(1));
                        dispatch(this.changeSubTabIndexAction(1));
                        if (useInfo.instrumentalId) {
                            dispatch(this.setIncidentalAudioStatusAction(FJConstant.SUCCESS));
                            dispatch(
                                this.setIncidentalAudioInfoAction({
                                    url:
                                        useInfo.instrumentalSource === FJConstant.AI_AUDIO_S3
                                            ? FJS3Config.S3_SERVER_HOST +
                                              FJConfig.originalSongKey +
                                              useInfo.instrumentalId
                                            : window.location.origin +
                                              FJConfig.presetPreviewPath +
                                              'audio/' +
                                              useInfo.instrumentalId,
                                    name: useInfo.instrumentalName,
                                    source: useInfo.instrumentalSource,
                                }),
                            );
                        }
                    }
                } else if (job_type === 21) {
                    dispatch(this.changeTabIndexAction(2));
                    dispatch(this.changeSFXPromptAction(prompt));
                } else if (job_type === 29) {
                    dispatch(this.changeTabIndexAction(0));
                    if (gen_scene === FJConstant.AUDIO_GEN_SCENE_MUSIC) {
                        dispatch(this.changeSubTabIndexAction(0));
                        dispatch(this.changeMusicPromptAction(prompt));
                        dispatch(this.changeMusicDurationAction(audio_duration));
                        if (lyrics) {
                            dispatch(this.toggleT2MLyricsEnabledAction(true));
                            dispatch(this.changeT2MLyricContentAction(lyrics));
                        }
                    } else if (gen_scene === FJConstant.AUDIO_GEN_SCENE_ACCOMPANY) {
                        dispatch(this.changeSubTabIndexAction(1));
                        dispatch(this.changeInstrumentalPromptAction(prompt));
                        dispatch(this.changeInstrumentalDurationAction(audio_duration));
                    }
                } else {
                    dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
                    dispatch(
                        this.setAudioInfoAction({
                            url: recIdInfo.url,
                            name: recIdInfo.name,
                            source: recIdInfo.source,
                        }),
                    );
                }
            }

            const tabType = FJUtil.getQueryString('tab_type');
            if (tabType) {
                const tabIndex = tabType === 'sfx' ? 2 : 0;
                dispatch(this.changeTabIndexAction(tabIndex));
            }

            dispatch(this._initPresetAIAudioAction());
            // dispatch(this.updateHistoryListAction());
        };
    },

    _initPresetAIAudioAction: function () {
        return async dispatch => {
            const response = await fetch(FJConfig.presetListJsonPath);
            const { list: presetList, sfxList, insList: insPreviewList } = await response.json();
            const usePresetList = presetList.map(item => {
                return {
                    ...item,
                    coverUrl: FJConfig.presetPreviewPath + 'image/' + item.fileName.replace('.mp3', '.png'),
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                    presetType: FJConstant.AUDIO_TAG_TYPE_MUSIC,
                    useStyle: item.style?.toLowerCase().replaceAll(' ', '-').replaceAll(',', ''),
                    usePrompt: item.prompt?.toLowerCase().replaceAll(' ', '-').replaceAll(',', '').replaceAll('.', ''),
                };
            });

            const useSfxList = sfxList.map(item => {
                return {
                    ...item,
                    coverUrl: FJConfig.presetPreviewPath + 'image/' + item.fileName.replace('.wav', '.png'),
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                    presetType: FJConstant.AUDIO_TAG_TYPE_SFX,
                    usePrompt: item.prompt?.toLowerCase().replaceAll(' ', '-').replaceAll(',', ''),
                };
            });

            const useInsList = insPreviewList.map(item => {
                return {
                    ...item,
                    coverUrl: FJConfig.presetPreviewPath + 'image/' + item.fileName.replace('.mp3', '.png'),
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                    presetType: FJConstant.AUDIO_TAG_TYPE_INST,
                    useStyle: item.style?.toLowerCase().replaceAll(' ', '-').replaceAll(',', ''),
                };
            });

            const _shuffleArray = array => {
                for (let i = array.length - 1; i > 0; i--) {
                    // Generate a random index j such that 0 <= j <= i
                    const j = Math.floor(Math.random() * (i + 1));
                    // Swap elements at indexes i and j
                    [array[i], array[j]] = [array[j], array[i]];
                }
                return array;
            };

            dispatch(setSlicePresetList(_shuffleArray(usePresetList)));
            dispatch(setSliceSFXPresetList(_shuffleArray(useSfxList)));
            dispatch(setSliceInsPresetList(_shuffleArray(useInsList)));

            const referenceResponse = await fetch(FJConfig.referencePresetListJsonPath);
            const { referenceMusicList, referenceVocalList, instrumentalList } = await referenceResponse.json();

            const musicList = referenceMusicList.map(item => {
                return {
                    ...item,
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                };
            });

            const vocalList = referenceVocalList.map(item => {
                return {
                    ...item,
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                };
            });

            const insList = instrumentalList.map(item => {
                return {
                    ...item,
                    audioUrl: window.location.origin + FJConfig.presetPreviewPath + 'audio/' + item.fileName,
                };
            });

            dispatch(setSliceReferenceMusicList(musicList));
            dispatch(setSliceReferenceVocalList(vocalList));
            dispatch(setSliceInstrumentalList(insList));
        };
    },

    onUseSampleInAudioFileAction: function () {
        return (dispatch, getState) => {
            FJAudioPlayManager.pauseAll();
            const state = getState();
            const referenceMusicList = state.AIAudioGenerator.referenceMusicList;
            const audioInfo = state.AIAudioGenerator.audioInfo;

            const __getRandom = () => {
                const randomIndex = Math.floor(Math.random() * referenceMusicList.length);

                if (referenceMusicList[randomIndex].name === audioInfo.name) {
                    return __getRandom();
                }
                return referenceMusicList[randomIndex];
            };

            const currentInfo = __getRandom();

            dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.setAudioInfoAction({
                    url: currentInfo.audioUrl,
                    duration: currentInfo.time,
                    name: currentInfo.name,
                    source: FJConstant.AI_AUDIO_FLEXCLIP,
                }),
            );
        };
    },

    onUseSampleInVoiceFileAction: function () {
        return (dispatch, getState) => {
            FJAudioPlayManager.pauseAll();
            const state = getState();

            const referenceVocalList = state.AIAudioGenerator.referenceVocalList;
            const vocalAudioInfo = state.AIAudioGenerator.vocalAudioInfo;

            const __getRandom = () => {
                const randomIndex = Math.floor(Math.random() * referenceVocalList.length);

                if (referenceVocalList[randomIndex].name === vocalAudioInfo.name) {
                    return __getRandom();
                }
                return referenceVocalList[randomIndex];
            };

            const currentInfo = __getRandom();

            dispatch(this.setVocalAudioStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.setVocalAudioInfoAction({
                    url: currentInfo.audioUrl,
                    duration: currentInfo.time,
                    name: currentInfo.name,
                    source: FJConstant.AI_AUDIO_FLEXCLIP,
                }),
            );
        };
    },

    onUseSampleInIncidentalFileAction: function () {
        return (dispatch, getState) => {
            FJAudioPlayManager.pauseAll();
            const state = getState();
            const instrumentalList = state.AIAudioGenerator.instrumentalList;
            const incidentalAudioInfo = state.AIAudioGenerator.incidentalAudioInfo;

            const __getRandom = () => {
                const randomIndex = Math.floor(Math.random() * instrumentalList.length);

                if (instrumentalList[randomIndex].name === incidentalAudioInfo.name) {
                    return __getRandom();
                }
                return instrumentalList[randomIndex];
            };

            const currentInfo = __getRandom();

            dispatch(this.setIncidentalAudioStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.setIncidentalAudioInfoAction({
                    url: currentInfo.audioUrl,
                    duration: currentInfo.time,
                    name: currentInfo.name,
                    source: FJConstant.AI_AUDIO_FLEXCLIP,
                }),
            );
        };
    },

    onUsePresetInfoAction: function (info) {
        return (dispatch, getState) => {
            const { tabIndex } = getState().AIAudioGenerator;
            FJAudioPlayManager.pauseAll();
            const { presetType } = info;
            if (tabIndex === 0) {
                switch (presetType) {
                    case FJConstant.AUDIO_TAG_TYPE_MUSIC:
                        dispatch(this.changeMusicPromptAction(`${info.style}. ${info.prompt}`));
                        // dispatch(this.changeMusicStylesAction());
                        break;
                    case FJConstant.AUDIO_TAG_TYPE_INST:
                        dispatch(this.changeInstrumentalPromptAction(info.style));
                        // dispatch(this.changeInstrumentStylesAction());
                        break;
                    case FJConstant.AUDIO_TAG_TYPE_SFX:
                        dispatch(this.changeSFXPromptAction(info.prompt));
                        break;
                    default:
                }
            } else if (tabIndex === 1 || tabIndex === 2) {
                switch (presetType) {
                    case FJConstant.AUDIO_TAG_TYPE_MUSIC:
                        dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
                        dispatch(
                            this.setAudioInfoAction({
                                url: info.audioUrl,
                                duration: info.time,
                                name: info.name,
                                source: FJConstant.AI_AUDIO_FLEXCLIP,
                            }),
                        );
                        break;
                    case FJConstant.AUDIO_TAG_TYPE_INST:
                        dispatch(this.setIncidentalAudioStatusAction(FJConstant.SUCCESS));
                        dispatch(
                            this.setIncidentalAudioInfoAction({
                                url: info.audioUrl,
                                duration: info.time,
                                name: info.name,
                                source: FJConstant.AI_AUDIO_FLEXCLIP,
                            }),
                        );
                        break;
                    case FJConstant.AUDIO_TAG_TYPE_SFX:
                        dispatch(this.changeSFXPromptAction(info.prompt));
                        break;
                    default:
                }
            }
        };
    },

    updateHistoryListAction: function (options = {}) {
        return async (dispatch, getState) => {
            const { ignoreLoading = false, callback = () => {} } = options;

            !ignoreLoading && dispatch(setSliceHistoryListLoadStatusAction(FJConstant.LOADING));
            try {
                const list = await FJNetworkStore.getTaskList(FJConfig.historyListType.join(','));

                if (list && list.length) {
                    const historyList = list.map(item => {
                        const info = JSON.parse(item.info);
                        const audioName = info.musicName;
                        const _prompt =
                            item.job_type === 29
                                ? _combinePrompt(
                                      item?.request_params?.origin_prompt,
                                      item?.request_params?.tag_style || undefined,
                                  )
                                : item?.request_params?.prompt;
                        const _lyrics =
                            item.job_type === 17
                                ? _removeTrailingHash(item?.request_params?.lyrics) // 删除音乐生音乐歌词末尾后端生成的 ‘##’
                                : item?.request_params?.lyrics;
                        return {
                            job_type: item.job_type,
                            status: item?.request_params?.state,
                            lyrics: _lyrics,
                            info: JSON.parse(item.info),
                            id: item.id,
                            createTime: item.created_at,
                            shareKey: item.share_key,
                            eventId: item.event_id,
                            audioName,
                            audioUrl: FJS3Config.S3_SERVER_HOST + FJConfig.resultSongKey + item.result,
                            coverName: info.coverName,
                            coverUrl: info.coverName
                                ? FJS3Config.S3_SERVER_HOST + FJConfig.resultSongKey + 'cover/' + info.coverName
                                : FJConfig.coverPath,
                            audioWaveImgUrl:
                                (info.audioWaveImgUrl
                                    ? FJS3Config.S3_SERVER_HOST + FJConfig.waveformKey + info.audioWaveImgUrl
                                    : null) || null,
                            audioWavePlayImgUrl:
                                (info.audioWavePlayImgUrl
                                    ? FJS3Config.S3_SERVER_HOST + FJConfig.waveformKey + info.audioWavePlayImgUrl
                                    : null) || null,
                            audioTagType:
                                item.job_type === 21
                                    ? FJConstant.AUDIO_TAG_TYPE_SFX
                                    : item.job_type === 29
                                      ? item?.request_params?.gen_scene === FJConstant.AUDIO_GEN_SCENE_ACCOMPANY
                                          ? FJConstant.AUDIO_TAG_TYPE_INST
                                          : FJConstant.AUDIO_TAG_TYPE_MUSIC
                                      : info.instrumentalId
                                        ? FJConstant.AUDIO_TAG_TYPE_INST
                                        : FJConstant.AUDIO_TAG_TYPE_MUSIC,
                            prompt: item?.request_params?.input_prompt || _prompt,
                            tagStyle: item?.request_params?.tag_style,
                            origin_prompt: item?.request_params?.origin_prompt,
                            audioDuration: item?.request_params?.audio_duration,
                        };
                    });
                    const oldHistoryList = getState().common.historyList;
                    if (JSON.stringify(oldHistoryList) !== JSON.stringify(historyList)) {
                        dispatch(setSliceHistoryListAction(historyList));
                    }
                    dispatch(this.dealAudioWaveAction());
                    callback(historyList);
                } else {
                    dispatch(setSliceHistoryListAction([]));
                    callback([]);
                }
                dispatch(this.checkedUpdateTaskStatusAction());
                !ignoreLoading && dispatch(setSliceHistoryListLoadStatusAction(FJConstant.SUCCESS));
            } catch (error) {
                !ignoreLoading && dispatch(setSliceHistoryListLoadStatusAction(FJConstant.ERROR));
            }
        };
    },

    dealAudioWaveAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const historyList = state.common.historyList;
            const needWaveList = historyList.filter(
                item => item.status === 'completed' && (!item.audioWaveImgUrl || !item.audioWavePlayImgUrl),
            );
            if (needWaveList.length === 0) {
                return;
            }
            const curItem = needWaveList[0];
            if (f_currentWaveId === curItem.eventId) {
                return;
            }
            f_currentWaveId = curItem.eventId;
            const imgUrl = await FJUtil.getAudioWave(curItem.audioUrl);
            const hoverImgUrl = await FJUtil.getAudioWave(curItem.audioUrl, true);

            try {
                const file = await FJUtil.getBlobByUrl(imgUrl);
                const id = await FJUtil.hashEncode(file);
                const key = FJConfig.waveformKey + id + '.png';
                const result = await FJImageStore.upLoadFileToS3Async(file, key);

                const hoverFile = await FJUtil.getBlobByUrl(hoverImgUrl);
                const hoverId = await FJUtil.hashEncode(hoverFile);
                const hoverKey = FJConfig.waveformKey + hoverId + '.png';
                const hoverResult = await FJImageStore.upLoadFileToS3Async(hoverFile, hoverKey);

                if (result && hoverResult) {
                    await FJNetworkStore.updateEventInfo({
                        eventId: curItem.eventId,
                        info: {
                            audioWaveImgUrl: id + '.png',
                            audioWavePlayImgUrl: hoverId + '.png',
                        },
                    });
                    const nowHistoryList = getState().common.historyList;
                    const temp = [];
                    nowHistoryList.forEach(item => {
                        if (item.eventId === curItem.eventId) {
                            temp.push({
                                ...item,
                                audioWaveImgUrl: FJS3Config.S3_SERVER_HOST + key,
                                audioWavePlayImgUrl: FJS3Config.S3_SERVER_HOST + hoverKey,
                            });
                        } else {
                            temp.push({
                                ...item,
                            });
                        }
                    });
                    f_currentWaveId = null;
                    dispatch(setSliceHistoryListAction(temp));
                    dispatch(this.dealAudioWaveAction());
                } else {
                    f_currentWaveId = null;
                    dispatch(this.dealAudioWaveAction());
                }
            } catch (e) {
                console.log(e);
                f_currentWaveId = null;
            }
        };
    },

    /**
     * @description 上传音频
     * @param file
     * @returns {(function(*, *): Promise<void>)|*}
     */
    uploadAudioFileAction: function (file) {
        return async (dispatch, getState) => {
            const uploadStatus = getState().AIAudioGenerator.uploadStatus;
            if (uploadStatus === FJConstant.LOADING) {
                return;
            }
            const isAudio = FJUtil.isAudio(
                file,
                UPLOAD_FILE_TYPE_OF_AUDIO + ',application/octet-stream, binary/octet-stream',
            );

            if (!isAudio) {
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'audio',
                            outputFormat: 'wav',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadAudioFileAction(newFiles[0]));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    let resultFile = result.files[0];

                    // 兼容Safari浏览器
                    const isSafari = FJUtil.getBrowser().includes('Safari');
                    const isFirefox = FJUtil.getBrowser().includes('FF');
                    if (isSafari || isFirefox) {
                        resultFile = new File([resultFile], resultFile.name.split('.')[0] + '.mp3', {
                            type: 'audio/mpeg',
                        });
                    }
                    file = resultFile;
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('please-upload-audio-in-mp3-and-wav-formats'),
                            'error',
                        );
                    }
                    dispatch(this.setUploadAudioStatusAction(FJConstant.DEFAULT));
                    return;
                }
            }

            // 处理支持的音频格式
            try {
                dispatch(this.setUploadAudioStatusAction(FJConstant.LOADING));
                const audioUrl = URL.createObjectURL(file);
                const audioDuration = await FJUtil.getAudioDurationWithUrl(audioUrl);
                if (audioDuration < 15) {
                    _time15Error();
                    dispatch(this.setUploadAudioStatusAction(uploadStatus));
                    return;
                } else if (audioDuration > 10 * 60) {
                    dispatch(this.setUploadAudioStatusAction(uploadStatus));
                    _time600Error();
                    return;
                }
                dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
                dispatch(
                    this.setAudioInfoAction({
                        url: audioUrl,
                        duration: FJUtil.formatTime(audioDuration, false, 2),
                        name: file.name,
                        type: 'local',
                    }),
                );
            } catch (error) {
                console.error(error);
                FJMessageStore.addMessage(FJLocalStore._('analysis-failed-please-try-again'), 'error');
                dispatch(this.setUploadAudioStatusAction(FJConstant.DEFAULT));
                return;
            }
        };
    },

    clearAudioInfoAction: function () {
        return dispatch => {
            dispatch(this.setUploadAudioStatusAction(FJConstant.DEFAULT));
            dispatch(this.setAudioInfoAction({}));
        };
    },

    /**
     * @description 上传人声
     * @param file
     * @returns {(function(*, *): Promise<void>)|*}
     */
    uploadVocalAudioFileAction: function (file) {
        return async (dispatch, getState) => {
            const uploadStatus = getState().AIAudioGenerator.uploadVocalAudioStatus;
            if (uploadStatus === FJConstant.LOADING) {
                return;
            }
            const isAudio = FJUtil.isAudio(
                file,
                UPLOAD_FILE_TYPE_OF_AUDIO + ',application/octet-stream, binary/octet-stream',
            );

            if (!isAudio) {
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'audio',
                            outputFormat: 'wav',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadVocalAudioFileAction(newFiles[0]));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    let resultFile = result.files[0];
                    // 兼容Safari浏览器
                    const isSafari = FJUtil.getBrowser().includes('Safari');
                    const isFirefox = FJUtil.getBrowser().includes('FF');
                    if (isSafari || isFirefox) {
                        resultFile = new File([resultFile], resultFile.name.split('.')[0] + '.mp3', {
                            type: 'audio/mpeg',
                        });
                    }
                    file = resultFile;
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('please-upload-audio-in-mp3-and-wav-formats'),
                            'error',
                        );
                    }
                    dispatch(this.setVocalAudioStatusAction(FJConstant.DEFAULT));
                    return;
                }
            }

            // 处理支持的音频格式
            dispatch(this.setVocalAudioStatusAction(FJConstant.LOADING));

            try {
                const audioUrl = URL.createObjectURL(file);
                const audioDuration = await FJUtil.getAudioDurationWithUrl(audioUrl);
                if (audioDuration < 15) {
                    _time15Error();
                    dispatch(this.setVocalAudioStatusAction(uploadStatus));
                    return;
                } else if (audioDuration > 10 * 60) {
                    dispatch(this.setVocalAudioStatusAction(uploadStatus));
                    _time600Error();
                    return;
                }
                dispatch(this.setVocalAudioStatusAction(FJConstant.SUCCESS));
                dispatch(
                    this.setVocalAudioInfoAction({
                        url: audioUrl,
                        duration: FJUtil.formatTime(audioDuration, false, 2),
                        name: file.name,
                        type: 'local',
                    }),
                );
            } catch (error) {
                console.error(error);
                FJMessageStore.addMessage(FJLocalStore._('analysis-failed-please-try-again'), 'error');
                dispatch(this.setVocalAudioStatusAction(FJConstant.DEFAULT));
                return;
            }
        };
    },

    clearVocalAudioInfoAction: function () {
        return dispatch => {
            dispatch(this.setVocalAudioStatusAction(FJConstant.DEFAULT));
            dispatch(this.setVocalAudioInfoAction({}));
        };
    },

    /**
     * @description 上传伴奏
     * @param file
     * @returns {(function(*, *): Promise<void>)|*}
     */
    uploadIncidentalAudioFileAction: function (file) {
        return async (dispatch, getState) => {
            const uploadStatus = getState().AIAudioGenerator.uploadIncidentalAudioStatus;
            if (uploadStatus === FJConstant.LOADING) {
                return;
            }
            const isAudio = FJUtil.isAudio(
                file,
                UPLOAD_FILE_TYPE_OF_AUDIO + ',application/octet-stream, binary/octet-stream',
            );
            if (!isAudio) {
                // 使用转码功能
                try {
                    const result = await dispatch(
                        FJActionModal.showCloudTranscodingModalAction({
                            files: [file],
                            mediaType: 'audio',
                            outputFormat: 'wav',
                            onReupload: newFiles => {
                                if (newFiles && newFiles.length > 0) {
                                    // 重新上传文件
                                    dispatch(this.uploadIncidentalAudioFileAction(newFiles[0]));
                                }
                            },
                        }),
                    );
                    // 直接使用转码后的文件
                    let resultFile = result.files[0];
                    // 兼容Safari浏览器
                    const isSafari = FJUtil.getBrowser().includes('Safari');
                    const isFirefox = FJUtil.getBrowser().includes('FF');
                    if (isSafari || isFirefox) {
                        resultFile = new File([resultFile], resultFile.name.split('.')[0] + '.mp3', {
                            type: 'audio/mpeg',
                        });
                    }
                    file = resultFile;
                } catch (e) {
                    if (e.cause === FJConstant.INVALID) {
                        FJMessageStore.addMessage(
                            FJLocalStore._('please-upload-audio-in-mp3-and-wav-formats'),
                            'error',
                        );
                    }
                    dispatch(this.setIncidentalAudioStatusAction(FJConstant.DEFAULT));
                    return;
                }
            }

            try {
                dispatch(this.setIncidentalAudioStatusAction(FJConstant.LOADING));
                const audioUrl = URL.createObjectURL(file);
                const audioDuration = await FJUtil.getAudioDurationWithUrl(audioUrl);
                if (audioDuration < 15) {
                    _time15Error();
                    dispatch(this.setIncidentalAudioStatusAction(uploadStatus));
                    return;
                } else if (audioDuration > 10 * 60) {
                    dispatch(this.setIncidentalAudioStatusAction(uploadStatus));
                    _time600Error();
                    return;
                }
                dispatch(this.setIncidentalAudioStatusAction(FJConstant.SUCCESS));
                dispatch(
                    this.setIncidentalAudioInfoAction({
                        url: audioUrl,
                        duration: FJUtil.formatTime(audioDuration, false, 2),
                        name: file.name,
                        type: 'local',
                    }),
                );
            } catch (error) {
                console.error(error);
                FJMessageStore.addMessage(FJLocalStore._('analysis-failed-please-try-again'), 'error');
                dispatch(this.setIncidentalAudioStatusAction(FJConstant.DEFAULT));
                return;
            }
        };
    },

    clearIncidentalAudioInfoAction: function () {
        return dispatch => {
            dispatch(this.setIncidentalAudioStatusAction(FJConstant.DEFAULT));
            dispatch(this.setIncidentalAudioInfoAction({}));
        };
    },

    /**
     * @deprecated
     */
    onLyricContentChangeAction: function (value) {
        return dispatch => {
            dispatch(this.changeM2MLyricContentAction(value));
        };
    },

    onLyricDescChangeAction: function (value) {
        return dispatch => {
            dispatch(this.setLyricDescAction(value));
        };
    },

    /**
     * @description 通过AI生成歌词
     * @returns {(function(*, *): Promise<void>)|*}
     */
    generateLyricAction: function () {
        return async (dispatch, getState) => {
            if (!FJUtil.isLogin()) {
                FJUtil.login();
                return;
            }

            const state = getState();
            const lyricDesc = state.AIAudioGenerator.lyricDesc;
            FJUtil.eaLog('ai lyric generate click', { prompt: lyricDesc });
            const _prompt = lyricDesc.replace(/\s/g, '');
            if (_prompt.length === 0 || lyricDesc.length === 0) {
                FJMessageStore.addMessage(FJLocalStore._('please-enter-the-lyrics-description'), 'error');
                return;
            }
            try {
                dispatch(setSliceIsGenerateLyricsLoading(true));
                const result = await FJNetworkStore.generateLyric({ content: lyricDesc });
                dispatch(this.changeM2MLyricContentAction(result.data.result));
            } catch (e) {
                FJMessageStore.addMessage(FJLocalStore._('lyrics-generation-failed'), 'error');
            } finally {
                dispatch(setSliceIsGenerateLyricsLoading(false));
            }
        };
    },

    generateErrorAction: function () {
        return () => {
            FJMessageStore.addMessage(FJLocalStore._('failed-to-create-task'), 'error');
        };
    },

    // TODO: refactor this function
    onGenerateAction: function () {
        return async (dispatch, getState) => {
            dispatch(FJActionAIAudioGenerator.setIsMultipleModeAction(false));
            dispatch(setSliceSelectListAction([]));

            const state = getState();
            const creditNumber = state.common.creditNumber;

            const {
                tabIndex,
                subTabIndex,

                // T2M 相关 tabIndex === 0
                isEnableLyricsT2M,
                t2mLyricContent,
                musicPrompt,
                instrumentalPrompt,
                musicDuration,
                instrumentalDuration,
                musicStyles: _musicStyles,
                instrumentStyles: _instrumentStyles,

                // M2M 相关 tabIndex === 1
                m2mLyricContent,
                audioInfo,
                vocalAudioInfo,
                incidentalAudioInfo,

                // SFX 相关 tabIndex === 2
                sfxPrompt,
            } = state.AIAudioGenerator;

            const musicStyles = _musicStyles.map(style => FJLocalStore._(style));
            const instrumentStyles = _instrumentStyles.map(style => FJLocalStore._(style));

            // 获取对应模式的免费次数
            let freeNumCreation = 0;
            if (tabIndex === 0) {
                // T2M 模式
                freeNumCreation =
                    subTabIndex === 0
                        ? state.AIAudioGenerator.textToMusicFreeNum
                        : state.AIAudioGenerator.textToAccompanyFreeNum;
            } else if (tabIndex === 1) {
                // M2M 模式
                freeNumCreation =
                    subTabIndex === 0
                        ? state.AIAudioGenerator.musicToMusicFreeNum
                        : state.AIAudioGenerator.musicToInstFreeNum;
            } else {
                // SFX 模式
                freeNumCreation = state.AIAudioGenerator.sfxFreeNum;
            }

            const _lyricContent =
                tabIndex === 0 ? t2mLyricContent.replace(/\s/g, '') : m2mLyricContent.replace(/\s/g, '');
            // 前端用户输入校验
            if (tabIndex === 0) {
                // T2M 校验
                if (subTabIndex === 0) {
                    // 音乐
                    if (!musicPrompt) {
                        FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                        return;
                    }
                    if (isEnableLyricsT2M && (_lyricContent.length === 0 || t2mLyricContent.length === 0)) {
                        FJMessageStore.addMessage(FJLocalStore._('please-enter-the-lyrics-first'), 'error');
                        return;
                    }
                    const realMusicPrompt = musicPrompt + (musicStyles.length > 0 ? ',' + musicStyles.join(',') : '');
                    if (
                        FJUtil.getByteLen(realMusicPrompt) < 10 ||
                        (isEnableLyricsT2M && FJUtil.getByteLen(_lyricContent) < 10)
                    ) {
                        FJMessageStore.addMessage(FJLocalStore._('a-minimum-of-10-characters-is-required'), 'error');
                        return;
                    }
                } else if (subTabIndex === 1) {
                    // 伴奏
                    if (!instrumentalPrompt) {
                        FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                        return;
                    }
                }
            } else if (tabIndex === 1) {
                // M2M 校验
                if (subTabIndex === 0) {
                    // 音乐
                    if (!audioInfo.url) {
                        FJMessageStore.addMessage(FJLocalStore._('please-upload-reference-music-first'), 'error');
                        return;
                    }
                    if (_lyricContent.length === 0 || m2mLyricContent.length === 0) {
                        FJMessageStore.addMessage(FJLocalStore._('please-enter-the-lyrics-first'), 'error');
                        return;
                    }
                } else if (subTabIndex === 1) {
                    // 伴奏
                    if (!incidentalAudioInfo.url) {
                        FJMessageStore.addMessage(FJLocalStore._('please-upload-reference-music-first'), 'error');
                        return;
                    }
                }
            } else if (tabIndex === 2) {
                const _prompt = sfxPrompt.replace(/\s/g, '');
                if (_prompt.length === 0 || sfxPrompt.length === 0) {
                    FJMessageStore.addMessage(FJLocalStore._('please-enter-the-prompt'), 'error');
                    return;
                }
            }

            dispatch(setSliceTaskStatusAction(FJConstant.START));

            // TODO: remove these userSpaceType
            const userSpaceType = await FJUtil.checkUserSpace({
                errorCallback: () => {
                    dispatch(this.generateErrorAction());
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                },
            });
            if (userSpaceType > 0) {
                dispatch(FJActionCommon.userSpaceChangeAction(userSpaceType));
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            if (AI_AUDIO_USE_CREDIT > creditNumber && freeNumCreation === 0) {
                dispatch(FJActionModal.showUpgradeModalAction());
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                return;
            }

            const _dealFile = async info => {
                const file = await FJUtil.getBlobByUrl(info.url);
                const id = await FJUtil.hashEncode(file);

                const key = FJConfig.originalSongKey + id + '.' + FJUtil.getFileSuffix(info.name);
                const result = await FJImageStore.upLoadFileToS3Async(file, key);
                if (result) {
                    return FJS3Config.S3_SERVER_HOST + key;
                } else {
                    dispatch(this.generateErrorAction());
                    dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
                }
            };

            let audioUrl = audioInfo.url;
            let voiceUrl = vocalAudioInfo.url;
            let incidentalUrl = incidentalAudioInfo.url;
            let lyrics = '';
            let prompt = '';
            let duration = 0;
            let info = {};
            let tagStyle = null;
            let originPrompt = '';

            const _getChatData = async _prompt => {
                try {
                    const lyricResult = await FJNetworkStore.getChatData({
                        stream: 0,
                        type: 11,
                        prompt: _prompt,
                    });
                    if (lyricResult) {
                        return lyricResult ?? '';
                    }
                } catch (e) {
                    dispatch(this.generateErrorAction());
                    console.error(e);
                }
            };

            if (tabIndex === 0) {
                // T2M prompt & lyrics 处理
                if (subTabIndex === 0) {
                    prompt = `${[musicPrompt.trim(), ...musicStyles].join(', ')}`;
                    originPrompt = musicPrompt.trim();
                    tagStyle = musicStyles.join(', ');
                    duration = musicDuration;
                    // 启用歌词时传递用户歌词, 否则根据 prompt AI生成
                    if (isEnableLyricsT2M) {
                        lyrics = t2mLyricContent;
                    } else {
                        lyrics = await _getChatData(prompt);
                    }
                } else if (subTabIndex === 1) {
                    prompt = `${[instrumentalPrompt.trim(), ...instrumentStyles].join(', ')}`;
                    originPrompt = instrumentalPrompt.trim();
                    tagStyle = instrumentStyles.join(', ');
                    duration = instrumentalDuration;
                    lyrics = null;
                }
            } else if (tabIndex === 1) {
                // M2M 音乐文件处理
                if (subTabIndex === 0) {
                    lyrics = m2mLyricContent;
                    incidentalUrl = null;
                    // 上传s3
                    if (audioInfo.type === 'local') {
                        audioUrl = await _dealFile(audioInfo);
                        if (!audioUrl) {
                            return;
                        }
                    }
                    info.songName = audioInfo.name;
                    info.songSource = audioInfo.source || FJConstant.AI_AUDIO_S3;

                    if (vocalAudioInfo.type === 'local') {
                        voiceUrl = await _dealFile(vocalAudioInfo);
                        if (!voiceUrl) {
                            return;
                        }
                    }
                    if (vocalAudioInfo.name) {
                        info.voiceName = vocalAudioInfo.name;
                        info.voiceSource = vocalAudioInfo.source || FJConstant.AI_AUDIO_S3;
                    }
                } else if (subTabIndex === 1) {
                    audioUrl = null;
                    voiceUrl = null;
                    lyrics = null;
                    if (incidentalAudioInfo.type === 'local') {
                        incidentalUrl = await _dealFile(incidentalAudioInfo);
                        if (!incidentalUrl) {
                            return;
                        }
                    }
                    info.instrumentalName = incidentalAudioInfo.name;
                    info.instrumentalSource = incidentalAudioInfo.source || FJConstant.AI_AUDIO_S3;
                }
            } else if (tabIndex === 2) {
                prompt = sfxPrompt;
            }

            FJUtil.eaLog('ai music generate click', {
                mode: tabIndex === 0 ? 'text' : tabIndex === 1 ? (subTabIndex === 0 ? 'music' : 'instrumental') : 'sfx',
                prompt: tabIndex !== 1 ? prompt : '',
            });
            FJUtil.eaLog(' ai tool start generating', {
                tool: FJUtil.getToolName(),
            });

            // AI生成音乐
            const _request = async () => {
                if (tabIndex === 0) {
                    return await FJNetworkStore.audioT2MGeneration({
                        prompt,
                        type:
                            subTabIndex === 0 ? FJConstant.AUDIO_GEN_SCENE_MUSIC : FJConstant.AUDIO_GEN_SCENE_ACCOMPANY,
                        lyrics,
                        duration,
                        tagStyle,
                        originPrompt,
                    });
                } else if (tabIndex === 1) {
                    return await FJNetworkStore.audioM2MGeneration({
                        audioUrl,
                        voiceUrl,
                        incidentalUrl,
                        lyrics,
                        info,
                    });
                } else if (tabIndex === 2) {
                    const isEnglish = FJUtil.isEnglish(prompt);
                    return await FJNetworkStore.soundEffectGeneration({
                        prompt,
                        isEnglish,
                    });
                }
            };

            try {
                await FJActionCommon.createRequestTask(_request, dispatch);

                FJUtil.updateAllCreditInfo();
                dispatch(this.updateHistoryListAction({ ignoreLoading: true }));

                if (tabIndex === 0 || tabIndex === 1) {
                    dispatch(this.setHistoryTabIndexAction(subTabIndex + 1));
                } else if (tabIndex === 2) {
                    dispatch(this.setHistoryTabIndexAction(tabIndex + 1));
                }

                dispatch(this.checkedUpdateTaskStatusAction());
            } catch (error) {
                console.log(error);
                dispatch(this.generateErrorAction());
            } finally {
                dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
            }
        };
    },

    checkedUpdateTaskStatusAction: function () {
        return dispatch => {
            if (f_timer) {
                return;
            }
            dispatch(this.pollingAudioGeneratorTaskListAction());
        };
    },

    pollingAudioGeneratorTaskListAction: function () {
        return async (dispatch, getState) => {
            const _clear = () => {
                if (f_timer) {
                    clearTimeout(f_timer);
                    f_timer = null;
                }
            };

            const state = getState();
            const historyList = state.common.historyList;
            const generatingTaskIdList = historyList
                .filter(item => item.status === 'progress')
                .map(item => item.eventId);

            if (generatingTaskIdList.length === 0) {
                _clear();
                return;
            }

            const delayTime = TASK_POLLING_INTERVAL * 5;
            const __pollingFunc = () => {
                dispatch(this.pollingAudioGeneratorTaskListAction());
            };

            try {
                const result = await FJNetworkStore.getTaskState(generatingTaskIdList.join(','));
                let isStopPolling = false;
                let data = result;

                if (!data) {
                    f_errorTime++;
                    if (f_errorTime >= MAX_POLLING_ERROR_TIME) {
                        _clear();
                    } else {
                        _clear();
                        f_timer = setTimeout(__pollingFunc, delayTime);
                    }
                    return;
                }

                if (!Array.isArray(result)) {
                    // 处理数组类型的data
                    data = [result];
                }

                let failTaskCount = 0;
                let isNeedUpdate = false;
                await Promise.all(
                    data.map(async item => {
                        switch (item.job_state) {
                            case 'succeeded':
                                dispatch(FJActionEditPage.updateAIToolListFromAIToolAction());
                                isNeedUpdate = true;
                                try {
                                    if (item.out_put) {
                                        const tempInfo = JSON.parse(item.out_put[0].info);
                                        FJUtil.eaLog('ai music generate success', {
                                            mode:
                                                item.job_type === 21
                                                    ? 'sfx'
                                                    : item.job_type === 29
                                                      ? 'text'
                                                      : tempInfo.songId
                                                        ? 'vocal'
                                                        : 'instrumental',
                                        });

                                        FJUtil.eaLog('ai tool generate success', {
                                            tool: FJUtil.getToolName(),
                                        });
                                    }
                                } catch (e) {
                                    console.log(e);
                                }

                                break;
                            case 'waiting':
                                break;
                            case 'processing':
                                break;
                            case 'canceled':
                                break;
                            case 'timeout':
                            case 'failed': {
                                isNeedUpdate = true;
                                failTaskCount++;
                                // TODO: 失败更新免费次数
                                FJUtil.updateAllCreditInfo(true);

                                if (failTaskCount === generatingTaskIdList.length) {
                                    isStopPolling = true;
                                }
                                let ealogReason = 'failed';
                                try {
                                    if (item.out_put) {
                                        const tempInfo = JSON.parse(item.out_put[0].info);
                                        if (
                                            tempInfo?.error?.indexOf(
                                                'Error generating music: Music upload failed: 1000',
                                            ) &&
                                            item.job_type !== 29
                                        ) {
                                            FJMessageStore.addMessage(
                                                FJLocalStore._('the-uploaded-music-has-no-sound'),
                                                'error',
                                            );
                                            ealogReason = 'no sound';
                                        } else {
                                            FJMessageStore.addMessage(
                                                FJLocalStore._('music-generation-failed'),
                                                'error',
                                            );
                                        }
                                    }
                                } catch (e) {
                                    console.log(e);
                                }
                                FJUtil.eaLog('ai music generate failed', { reason: ealogReason });
                                break;
                            }
                            default:
                                break;
                        }
                    }),
                );
                if (isStopPolling) {
                    _clear();
                } else {
                    _clear();
                    f_timer = setTimeout(__pollingFunc, delayTime);
                }
                if (isNeedUpdate) {
                    dispatch(this.updateHistoryListAction({ ignoreLoading: true }));
                }
            } catch (error) {
                console.log(error);
                _clear();
            }
        };
    },

    retryAIAudioAction: function (item) {
        return dispatch => {
            const info = item.info;
            switch (item.job_type) {
                case 21:
                    // 重试 sfx
                    dispatch(this.changeTabIndexAction(2));
                    dispatch(this.changeSFXPromptAction(item.prompt));
                    break;
                case 17:
                    // 重试 m2m
                    if (info.instrumentalId) {
                        // 伴奏生成
                        dispatch(this.changeTabIndexAction(1));
                        dispatch(this.changeSubTabIndexAction(1));
                        dispatch(this.setIncidentalAudioStatusAction(FJConstant.SUCCESS));
                        dispatch(
                            this.setIncidentalAudioInfoAction({
                                url:
                                    info.instrumentalSource === FJConstant.AI_AUDIO_S3
                                        ? FJS3Config.S3_SERVER_HOST + FJConfig.originalSongKey + info.instrumentalId
                                        : window.location.origin +
                                          FJConfig.presetPreviewPath +
                                          'audio/' +
                                          info.instrumentalId,
                                name: info.instrumentalName,
                                source: info.instrumentalSource,
                            }),
                        );
                    } else {
                        dispatch(this.changeTabIndexAction(1));
                        dispatch(this.changeSubTabIndexAction(0));
                        dispatch(this.setUploadAudioStatusAction(FJConstant.SUCCESS));
                        dispatch(
                            this.setAudioInfoAction({
                                url:
                                    info.songSource === FJConstant.AI_AUDIO_S3
                                        ? FJS3Config.S3_SERVER_HOST + FJConfig.originalSongKey + info.songId
                                        : window.location.origin + FJConfig.presetPreviewPath + 'audio/' + info.songId,
                                name: info.songName,
                                source: info.songSource,
                            }),
                        );
                        if (info.voiceId) {
                            dispatch(this.setVocalAudioStatusAction(FJConstant.SUCCESS));
                            dispatch(
                                this.setVocalAudioInfoAction({
                                    url:
                                        info.voiceSource === FJConstant.AI_AUDIO_S3
                                            ? FJS3Config.S3_SERVER_HOST + FJConfig.originalSongKey + info.voiceId
                                            : window.location.origin +
                                              FJConfig.presetPreviewPath +
                                              'audio/' +
                                              info.voiceId,
                                    name: info.voiceName,
                                    source: info.voiceSource,
                                }),
                            );
                        } else {
                            dispatch(this.setVocalAudioStatusAction(FJConstant.DEFAULT));
                            dispatch(this.setVocalAudioInfoAction({}));
                        }

                        const textArea = document.createElement('textarea');
                        textArea.value = item.lyrics;
                        dispatch(this.changeM2MLyricContentAction(textArea.value));
                    }
                    break;
                case 29:
                    // 重试 t2m
                    if (item.audioTagType === FJConstant.AUDIO_TAG_TYPE_MUSIC) {
                        dispatch(this.changeTabIndexAction(0));
                        dispatch(this.changeSubTabIndexAction(0));
                        dispatch(this.changeMusicPromptAction(item.prompt));
                        dispatch(this.changeMusicDurationAction(item.audioDuration));
                    } else if (item.audioTagType === FJConstant.AUDIO_TAG_TYPE_INST) {
                        dispatch(this.changeTabIndexAction(0));
                        dispatch(this.changeSubTabIndexAction(1));
                        dispatch(this.changeInstrumentalPromptAction(item.prompt));
                        dispatch(this.changeInstrumentalDurationAction(item.audioDuration));
                    }
            }
        };
    },

    applyRecordAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const audioName = state.record.audioName;
            const audioUrl = state.record.audioUrl;
            const mimeType = 'audio/mpeg';
            const audioBlob = await FJUtil.getBlobByUrl(audioUrl);
            const audioFile = new File([audioBlob], audioName, { type: mimeType });
            Download(audioFile, audioName, mimeType);
            dispatch(FJActionModal.hideRecordModalAction());
            dispatch(this.setVocalAudioStatusAction(FJConstant.SUCCESS));
            dispatch(
                this.setVocalAudioInfoAction({
                    url: audioUrl,
                    name: audioName,
                    type: 'local',
                }),
            );
            dispatch(FJActionRecord.setRecordStatusAction(FJConstant.DEFAULT));
            dispatch(FJActionRecord.setAudioUrlAction(''));
            dispatch(FJActionRecord.setAudioNameAction(''));
        };
    },

    addToMediaLibraryAction: function (ids) {
        return (dispatch, getState) => {
            const { historyList } = getState().common;
            const urls = historyList
                .filter(item => ids.includes(item.id) && item.status === 'completed')
                .map(item => item.audioUrl);

            if (urls.length === 0) {
                FJMessageStore.addMessage(FJLocalStore._('unable-to-perform-this-operation-video'), 'error');
                return;
            }

            if (urls.length === 1) {
                dispatch(FJActionEditPage.addToMediaLibraryAction(urls[0], { from: 'generate' }));
            } else {
                dispatch(FJActionEditPage.addMultipleMediaToMediaLibraryAction(urls, { from: 'generate' }));
            }
        };
    },

    /**
     * @description 获取灵感
     * @returns
     */
    getInspireAction: function () {
        return async (dispatch, getState) => {
            const state = getState();
            const tabIndex = state.AIAudioGenerator.tabIndex;
            const subTabIndex = state.AIAudioGenerator.subTabIndex;

            const curPrompt =
                tabIndex === 2
                    ? state.AIAudioGenerator.sfxPrompt
                    : subTabIndex === 0
                      ? state.AIAudioGenerator.musicPrompt
                      : state.AIAudioGenerator.instrumentalPrompt;

            const inspireListForT2M = [
                'Choral masterpiece of beauty and spirituality. Serene, transcendent.',
                'Pop-rock anthem of joy and freedom. Energetic, uplifting.',
                'Smooth jazz with romance and relaxation. Calm, sophisticated.',
                'Acoustic folk on nature and peace. Serene, reflective.',
                'Trance track of euphoria and connection. High-energy.',
                'Dance track of celebration and joy. Exuberant, lively.',
                'Pop-R&B of romance and longing. Tender, passionate.',
                'Hard rock of rebellion and adventure. Bold, energetic.',
                'Acoustic folk on journeys and belonging. Calm, heartfelt.',
                'Hip-hop rap of power and confidence. Intense, dominant.',
                'Orchestral piece of romance and beauty. Elegant, serene.',
                'Smooth jazz for relaxation and freedom. Sophisticated, calm.',
                'Indie rock of heartbreak and vulnerability. Melancholic, intimate.',
                'Trap hip-hop of power and intensity. Bold, explosive.',
                'Country-folk of nostalgia and home. Peaceful, melancholic.',
                'Synth-pop of freedom and unity. Vibrant, energetic.',
                'Acoustic folk on nature and introspection. Calm, soulful.',
                'Hip-hop rap of success and confidence. Dynamic, commanding.',
                'Alternative rock of resilience and power. Intense, driven.',
                'Pop anthem of youth and ambition. Hopeful, energetic.',
            ];
            const inspireListForSFX = [
                'Heavy rain mixed with thunder',
                'Many horses are running wildly on the grassland',
                'Typing on mechanical keyboard',
                'Supercar acceleration sprint',
                'Wind through pine trees',
                'Ocean waves crashing',
                'Seagull cry fading into distance',
                'Birds are singing in the rainforest',
                'The joyful sounds of children playing',
            ];

            const inspireList = tabIndex === 0 ? inspireListForT2M : inspireListForSFX;

            const __getRandomInspire = () => {
                const randomIndex = Math.floor(Math.random() * inspireList.length);

                if (inspireList[randomIndex] === curPrompt) {
                    return __getRandomInspire();
                }
                return inspireList[randomIndex];
            };

            const prompt = __getRandomInspire();

            if (tabIndex === 0) {
                if (subTabIndex === 0) {
                    dispatch(this.changeMusicPromptAction(prompt));
                } else if (subTabIndex === 1) {
                    dispatch(this.changeInstrumentalPromptAction(prompt));
                }
            } else if (tabIndex === 2) {
                dispatch(this.changeSFXPromptAction(prompt));
            }
        };
    },

    updateUseFreeLimitAction: function (info) {
        return dispatch => {
            // 更新 T2M 免费次数
            dispatch(setSliceTextToMusicFreeNum(info['text-to-music']));
            dispatch(setSliceTextToAccompanyFreeNum(info['text-to-accompany']));

            // 更新 M2M 免费次数
            dispatch(setSliceMusicToMusicFreeNum(info['music-generator']));
            dispatch(setSliceMusicToInstFreeNum(info['audio-accompany-generator']));

            // SFX
            dispatch(setSliceSFXFreeNumCreationAction(info['audio-effect-generator']));
        };
    },

    changeMusicDurationAction: function (duration) {
        return (dispatch, getState) => {
            const roundDuration = Math.round(duration);
            const currentDuration = getState().AIAudioGenerator.musicDuration;

            if (currentDuration === roundDuration) return;

            dispatch(setSliceMusicDuration(roundDuration));
        };
    },

    changeInstrumentalDurationAction: function (duration) {
        return (dispatch, getState) => {
            const roundDuration = Math.round(duration);
            const currentDuration = getState().AIAudioGenerator.instrumentalDuration;

            if (currentDuration === roundDuration) return;

            dispatch(setSliceInstrumentalDuration(roundDuration));
        };
    },

    changeSubTabIndexAction: function (index) {
        return dispatch => {
            dispatch(setSliceSubTabIndex(index));
        };
    },

    changeMusicStylesAction: function (styles) {
        return (dispatch, getState) => {
            const state = getState();
            const promptLength = FJUtil.getByteLen(state.AIAudioGenerator.musicPrompt);
            const styleLength = FJUtil.getByteLen(
                styles.length > 0 ? ',' + styles.map(style => FJLocalStore._(style)).join(',') : '',
            );
            const newPromptLength = promptLength + styleLength;
            if (newPromptLength > MAX_PROMPT_LENGTH) {
                FJMessageStore.addMessage(FJLocalStore._('new-music-prompt-char-limit-tip'), 'error');
                return;
            }
            dispatch(setSliceMusicStyles(styles));
        };
    },

    changeInstrumentStylesAction: function (styles) {
        return dispatch => {
            dispatch(setSliceInstrumentStyles(styles));
        };
    },

    changeM2MLyricContentAction: function (value) {
        return dispatch => {
            dispatch(setSliceM2MLyricContent(FJUtil.sliceByteLen(value, 350)));
        };
    },

    changeT2MLyricContentAction: function (value) {
        return dispatch => {
            dispatch(setSliceT2MLyricContent(value));
        };
    },

    changeMusicPromptAction: function (value) {
        return dispatch => {
            dispatch(setSliceMusicPrompt(value));
        };
    },

    changeInstrumentalPromptAction: function (value) {
        return dispatch => {
            dispatch(setSliceInstrumentalPrompt(FJUtil.sliceByteLen(value, 300)));
        };
    },

    toggleT2MLyricsEnabledAction: function (enabled) {
        return dispatch => {
            dispatch(setSliceIsEnableLyricsT2M(enabled));
        };
    },
};

export default FJActionAIAudioGenerator;
